var _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#D8D8D8",
    rx: 12.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gb_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#fff",
    rx: 12.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#gb_svg__a)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 25,
    x: -5,
    fill: "#fff",
    rx: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gb_svg__b",
    width: 35,
    height: 25,
    x: -5,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 25,
    x: -5,
    fill: "#fff",
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gb_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A17A7",
    d: "M-5 0h35v25H-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-6.603-2.396 8.333 7.68v-9.346h8.334V7.68L31.603-2.396 33.467.368l-11.81 7.965H30v8.334h-8.342l11.81 7.965-1.865 2.763-14.936-10.074v9.346H8.333V17.32L-6.603 27.395l-1.864-2.763 11.81-7.965H-5V8.333h8.342L-8.468.368z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M18.335 7.915 34.167-2.5M20.016 17.122l14.192 9.566M5.007 7.888-9.797-2.089M6.613 17.006l-16.41 10.882"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6273E",
    fillRule: "evenodd",
    d: "M-5 15h15v10h5V15h15v-5H15V0h-5v10H-5z",
    clipRule: "evenodd"
  })))));
};
export default SvgGb;